<div class="wk8-book-sentence" style="display: flex; column-gap: 0.35em; flex-wrap: wrap; align-items: center">
  @for (part of sentence().parts; track part.uid) {
    @switch (part.dataType) {
      @case ('Wk8BookSentencePartFilter') {
        @let text = getPartText(part);
        @let isFillingThisPart = enableWordFill() && target()?.uid === part.uid && enableTarget();

        @if (text && !isFillingThisPart) {
          <wk8-book-text style="font-style: italic; font-weight: bold">{{ text | trim }}</wk8-book-text>
        } @else {
          <span
            [class.clickable]="enableLevelSelect()"
            lpDropTarget
            [dropEnabled]="enableWordFill() && target()?.uid === part.uid && enableTarget()"
            (draggableAdded)="draggableAdded(part, $event)"
            (draggableRemoved)="emptyTarget(part)"
            (click)="enableLevelSelect() ? levelSelected.emit(part) : undefined"
            (pointerenter)="hovered.emit(part)"
            (pointerleave)="hovered.emit(undefined)"
            style="
              position: relative;
              display: inline-block;
              width: 8em;
              height: 1.5lh;
              margin-inline: 0.5em;
              white-space: pre;
              font-size: 0.5em;
            "
          >
            <svg
              class="dashes"
              [class.target]="target()?.uid === part.uid"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              width="100%"
              height="100%"
              style="position: absolute; inset: 0; overflow: visible"
            >
              <path
                d="M0,0 H100 V100 H0 Z"
                fill="none"
                stroke="black"
                stroke-width="2"
                vector-effect="non-scaling-stroke"
                stroke-linejoin="round"
                stroke-linecap="round"
                [style]="{
                  transition: 'stroke-dasharray 0.125s ease-out',
                  strokeDasharray: highlightedPart()?.uid === part.uid ? '32 0' : dashArray(),
                }"
              ></path>
            </svg>
            {{ ' ' }}
          </span>
        }
      }
      @case ('Wk8BookSentencePartPlain') {
        <wk8-book-text>{{ getPartText(part) | lowercase | trim }}</wk8-book-text>
      }
    }
  }
</div>
